import './container.scss'

interface Props {
  children: React.ReactNode
  className?: string
  padding?: boolean
  maxWidth?: boolean
}

const Container = ({
  children, className,
  padding = true, maxWidth = true,
}: Props) =>
  <div className={[
    'Component-Container',
    padding ? 'padding' : null,
    maxWidth ? 'maxWidth' : null,
    className || null,
  ].join(' ')}>
    {children}
  </div>

export default Container